'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  horizontal: {
    coordinate: 'x',
    dimension: 'width',
    direction: 'left'
  },
  vertical: {
    coordinate: 'y',
    dimension: 'height',
    direction: 'top'
  }
};